const labels = {
    product: 'Produit',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'Adresse e-mail',
    title: 'Fonction',
    company: 'Entreprise',
    country: 'Pays',
    phone: 'Numéro de telephone',

    checkbox: `Je suis d'accord avec <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">
la Politique de Confidentialité</a>
 et j'autorise l'utilisation des informations fournies à des fins de communication. 
 Je comprends que je peux retirer mon consentement 
 à tout moment en envoyant une demande à <a href="mailto:dataprotection@starwind.com">dataprotection@starwind.com</a>.`,

    checkbox_validation: `Veuillez confirmer que vous avez lu et accepté 
<a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">la Politique de confidentialité</a> 
avant de continuer.`,

    no_checkobox: `Veuillez confirmer que vous avez lu et accepté
 <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">la Politique de confidentialité</a> 
 avant de continuer.`,


    contentDefault: `
        <div id="download-thank-you" class="thank-you-text download-thank-you">
            <div class="flex-grid centered">
                <div class="message-wrap">
                    <div class="title">Merci!</div>
                    <div class="text">
                      La clé de licence pour {product_name_2024}<br> a déjà été envoyée à:<br> <b>{this.email}</b>
                      <br><br>
                      Si vous ne trouvez pas cet e-mail dans votre boîte de réception, veuillez vérifier votre dossier spam/indésirables.
                    </div>
                </div>
            </div>
        </div>`.trim(),

    contentNoLic: `<div id="download-thank-you" class="thank-you-text download-thank-you">
                    <div class="flex-grid centered">
                        <div class="message-wrap">
                            <div class="title">Merci !</div>
                            <div class="text">
                              Le lien de téléchargement pour {product_name_2024}<br> a déjà été envoyé à l'adresse e-mail:<br> <b>{this.email}</b>
                              <br><br>
                              Si vous ne trouvez pas l'e-mail dans votre boîte de réception, veuillez vérifier votre dossier de courrier indésirable/spam.
                            </div>
                        </div>
                    </div>
                </div>`.trim(),

    contentDefault2: `
                <div id="download-thank-you" class="thank-you-text download-thank-you">
                    <div class="flex-grid centered">
                        <div class="message-wrap">
                            <div class="title">Merci !</div>
                            <div class="text">
                                La clé de licence pour {product_name_2024}<br> a déjà été envoyée à:<br> <b>{this.email}</b>
                            </div>
                        </div>
                    </div>
                </div>`.trim(),

}

export {labels}